import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { usersApi } from "../../api/usersApi";
import { getErrorMessage } from "../../utils/getErrorMessage";

export default function UsersList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const load = async () => {
    setLoading(true);
    setErr("");
    try {
      const res = await usersApi.list();
      setItems(res.data || []);
    } catch (e) {
      setErr(getErrorMessage(e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const onDelete = async (id, username, roles) => {
    if ((roles || []).includes("superadmin")) return;
    if (!window.confirm(`${username} silinsin?`)) return;
    try {
      await usersApi.remove(id);
      await load();
    } catch (e) {
      alert(getErrorMessage(e));
    }
  };

  if (loading) return <div style={{ padding: 16 }}>Loading...</div>;

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
        <h1 style={{ margin: 0 }}>Users</h1>
        <Link className="btn" to="/users/new">+ Create</Link>
        <button className="btn ghost" onClick={load}>Refresh</button>
      </div>

      {err && (
        <div style={{ marginBottom: 12, color: "crimson", whiteSpace: "pre-wrap" }}>
          {err}
        </div>
      )}

      <div className="card">
        <table className="table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Email</th>
              <th>Roles</th>
              <th style={{ width: 220 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((x) => (
              <tr key={x.id}>
                <td>{x.username}</td>
                <td>{x.email}</td>
                <td>{(x.roles || []).join(", ")}</td>
                <td style={{ display: "flex", gap: 8 }}>
                  <Link className="btn" to={`/users/${x.id}`}>Edit</Link>
                  <button
                    className="btn danger"
                    onClick={() => onDelete(x.id, x.username, x.roles)}
                    disabled={(x.roles || []).includes("superadmin")}
                    title={(x.roles || []).includes("superadmin") ? "Superadmin silinmir" : ""}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr>
                <td colSpan={4} style={{ opacity: 0.7 }}>
                  No users
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
